// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"108":"60b4c10dcf9034f77687","293":"e184db4160ce5a6ce22d","452":"e5c57d66489174865f4b","577":"f73c03b8b796815ef95f"}[chunkId] + ".js";
};